export const SIGNUP_ROUTES = {
  SIGNUP: { path: '/signup' },
  LOGIN: { path: '/login' },
  VERIFY_OTP: { path: '/verifyOtp' },
  GST_DETAILS: { path: '/gstDetails' },
  WITHOUT_GSTIN: { path: '/withoutGstin' },
  COMPANY_DETAILS: { path: '/companyDetails' },
  CONTACT_DETAILS: { path: '/contactDetails' },
  BUSINESS_CATEGORY: { path: '/businessCategory' },
  YOUR_INDUSTRY: { path: '/yourIndustry' },
  LOADING: { path: '/loading' },
  LAUNCH: { path: '/launch' },
};

export const SIGNUP_ONBOARDING = {
  RETRAIN_AGENT: { path: '/onboarding/retrain' },
  TEST_AGENT: { path: '/onboarding' },
  VIEW_SAMPLE_FILE: { path: '/onboarding/view-sample-file' },
  SIGNUP_LAUNCH: { path: '/onboarding/launch' },
  SIGNUP_HOME: { path: '/home' },
};

export const AGENT_SETUP_ROUTE = { path: '/agentSetup' };

export const BUILD_KNOWLEDGE_ROUTES = {
  BUILD_KNOWLEDGE: { path: '/buildKnowledge' },
  UPLOAD_KNOWLEDGE: { path: '/buildKnowledge/uploadKnowledge' },
  AGENT_TRAINING: { path: '/buildKnowledge/agentTraining' },
  AGENT_READY: { path: '/buildKnowledge/agentReady' },
};

export const TEST_AGENT_ROUTES = {
  TEST_AGENT: { path: '/testAgent' },
  UPGRADE_KNOWLEDGE: { path: '/upgradeKnowledge' },
  AGENT_TRAINING: { path: '/upgradeKnowledge/agentTraining' },
  AGENT_READY: { path: '/upgradeKnowledge/agentReady' },
  DEPLOY_AGENT: { path: '/upgradeKnowledge/deployAgent' },
};

export const WABA_SETUP_ROUTES = {
  WABA_SETUP: { path: '/wabaSetup' },
  WABA_REQUIREMENTS: { path: '/wabaSetup/requirements' },
  WABA_SIGNUP: { path: '/wabaSetup/signUp' },
  WABA_LAUNCH: { path: '/wabaSetup/launch' },
  WABA_LOADER: { path: '/wabaSetup/loader' },
  WABA_FAILURE: { path: '/wabaSetup/failure' },
  WABA_SUCCESS: { path: '/wabaSetup/success' },
  WABA_GENERATE_LINK: { path: '/wabaSetup/generateLink' },
  WABA_COPY_SHORT_LINK: { path: '/wabaSetup/copyShortLink' },
  WABA_SKIP_LAUNCH: { path: '/wabaSetup/skipLaunch' },
  DEPLOY_AGENT_BOT_ADVANTAGES: { path: '/wabaSetup/botAdvantages' },
};
